/* esm.sh - applesauce-core@5.2.0/dist/helpers/time */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/time.mjs";
